export default {
  'GiglinkedMusicianAutocomplete.inviteMusicians': {
    en: 'Invite the musician(s)',
    fr: 'Inviter des musicien.ne.s',
  },
  'GiglinkedMusicianAutocomplete.invite': { en: 'Invite', fr: 'Inviter' },
};
